import React, { useContext, useEffect, useState } from "react";
import trans, { isRTL } from "../../../../utils";
import OffcanvasFooter from "../../../Helpers/Offcanvasfooter/OffcanvasFooter";
import PermissionsInfo from "./PermissionsInfo";
import PermissionsAccess from "./PermissionsAccess";
import * as Yup from "yup";
import { useFormik } from "formik";
import { popupcontext } from "../../../../context/Popupscontext";
import { toast } from "react-toastify";
import {
	useAddPermissionMutation,
	useEditPermissionMutation,
	useGetSpecificPermissionQuery,
} from "../../../../Redux/service/Roles&Permissions/RolesPermissions";
import Loader from "../../../Helpers/Loader/Loader";

export default function PermissionsBody() {
	const [submitAttempt, setSubmitAttempt] = useState(false);
	let { handleClose, isEditing, currentPermissionId, setReloadData } =
		useContext(popupcontext);
	const { data: Editvalues, refetch } = useGetSpecificPermissionQuery(
		currentPermissionId,
		{
			skip: !currentPermissionId,
		},
	);
	let [AddPermissions, { isLoading: AddLoading }] = useAddPermissionMutation();
	let [EditPermissions, { isLoading: EditLoading }] =
		useEditPermissionMutation();
	useAddPermissionMutation();
	let initialValues = {
		name: null,
		description: null,
		modules: null,
		submodules: [],
		resources: null,
		actions: null,
		userType: null,
		hierarchical_access: false,
	};
	let validSchema = Yup.object({
		name: Yup.string()
			.required(trans("Name is required"))
			.min(3, trans("Name must be at least 3 characters"))
			.max(20, trans("Name must be at most 20 characters"))
			.test(
				"not-empty-or-spaces",
				trans("Name cannot be just whitespace"),
				(value) => !!value && value.trim().length > 0,
			)
			.matches(
				/^[A-Za-z0-9\u0600-\u06FF\s]+$/,
				trans("Name cannot contain special characters"),
			),
		modules: Yup.string().required(trans("Module is required")),
		submodules: Yup.array()
			.min(1, trans("Sub-Module is required"))
			.required(trans("Sub-Module is required")),
		resources: Yup.string().required(trans("Resource is required")),
		actions: Yup.string().required(trans("Access Type is required")),

		userType: Yup.string().required(trans("User type is required")),
	});
	let addPermission = useFormik({
		initialValues,
		validationSchema: validSchema,
		onSubmit: async (val) => {
			try {
				if (isEditing) {
					console.log("val", val);
					let newVal = { ...val };

					const keysToDelete = [
						"createdAt",
						"createdBy",
						"updatedAt",
						"updatedBy",
						"updatedById",
						"createdById",
					];

					keysToDelete.forEach((key) => {
						if (key in newVal) delete newVal[key];
					});

					await EditPermissions({
						val: newVal,
						id: currentPermissionId,
					}).unwrap();
					toast.success(trans("Permission Edited Successfully"), {
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar" ? true : false,
					});
					setReloadData(true);
					refetch();
					handleClose("form");
				} else {
					await AddPermissions(val).unwrap();
					toast.success(trans("Permission Added Successfully"), {
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar" ? true : false,
					});
					setReloadData(true);
					handleClose("form");
				}
			} catch (error) {
				console.log("errr", error);
				toast.error(`${error?.data?.message}`, {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			}
		},
	});
	useEffect(() => {
		if (isEditing && Editvalues) {
			addPermission.setValues(Editvalues?.data);
			const data = Editvalues.data;
			addPermission.setFieldValue("name", data.name ?? null);
			addPermission.setFieldValue("description", data.description ?? null);
			addPermission.setFieldValue("modules", data.modules ?? null);
			addPermission.setFieldValue(
				"submodules",
				data?.submodules?.map((i) => i) ?? [],
			);
			addPermission.setFieldValue("resources", data.resources ?? null);
			addPermission.setFieldValue("actions", data.actions ?? null);
			addPermission.setFieldValue("userType", data.userType ?? null);
			addPermission.setFieldValue(
				"hierarchical_access",
				data.hierarchical_access ?? true,
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isEditing, Editvalues]);
	const handleSubmit = (e) => {
		e.preventDefault();
		setSubmitAttempt(true);
		addPermission.handleSubmit(e);
	};

	console.log("AddPErmis", addPermission);
	if (AddLoading)
		return (
			<div className="loader-container">
				<Loader />
			</div>
		);
	if (EditLoading)
		return (
			<div className="loader-container">
				<Loader />
			</div>
		);
	return (
		<div>
			<form dir={!isRTL ? "ltr" : "rtl"} onSubmit={handleSubmit}>
				<PermissionsInfo addData={addPermission} />
				<PermissionsAccess addData={addPermission} />
				<OffcanvasFooter
					addData={addPermission}
					submitAttempt={submitAttempt}
				/>
			</form>
		</div>
	);
}
